export enum CoordinateMode {
    City, // no radius, name will be a city name (default, if no mode is given)
    Radius, // radius just around given coordinates. No radius means a default radius = 1200m
    Zip, // ZIP code, no radius, "name" must be a number between 1000 and 9999, coordinates will not be used
    Kanton, // Kanton / State, coordinates are used, name will be the kanton (Swiss state) name
    Region, // Region concerning language, coordinates are used, name will be the region name
    Suburb, // Suburb, coordinates are used, name will be the region name
}

export enum RadiusType {
    Kilometers,
    Meters,
}

export interface CoordinateModel {
    city?: string;
    individualproduct?: string;
    latitude?: string | number;
    longitude?: string | number;
    mode: CoordinateMode;
    name?: string | number;
    phrase?: string | null;
    radius?: number | null;
}
